/*
 *
 * ChargebackDownloadPopup
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 15-Sep-2025
*/

import ChargebackDownloadPopup from './ChargebackDownloadPopupContainer'

export default ChargebackDownloadPopup
